$(function () {

    const AUTO_COMPLETE_SPEED = 400;

    let abortController = new AbortController();

    let search = '';

    jQuery.fn.scrollToElem = function(elem) {
        let parentDiv = $(this);
        parentDiv.scrollTop(parentDiv.scrollTop() + ($(elem).position().top - parentDiv.position().top) - (parentDiv.height()/2) + ($(elem).height()/2)  )
        return this; 
    };

    function isLTSearch(){
        return $('body').hasClass('livetrade-layout');
    }

    function addViewAllProducer(wines) {
        
        const producerCounts = wines.reduce((acc, wine) => {
            if (!acc[wine.productProducer]) {
                acc[wine.productProducer] = {
                    count: 0, 
                    imageUrl: wine.ImageUrl,
                    productProducer: wine.productProducer,
                    productType: wine.productType,
                };
            }
            acc[wine.productProducer].count += 1;
            return acc;
        }, {});

        biggestProducer = producerCounts[Object.keys(producerCounts).reduce((a, b) => producerCounts[a].count > producerCounts[b].count ? a : b)];

        if (biggestProducer.count >= wines.length / 2) {

            if (biggestProducer.productType.toLowerCase() === 'spirit') {
                producerUrl = `/fine-spirits/distiller/${encodeURIComponent(biggestProducer.productProducer.toLowerCase().replace(/ /g, "_"))}`;
            } else {
                producerUrl = `/fine-wine/producer/${encodeURIComponent(biggestProducer.productProducer.toLowerCase().replace(/ /g, "_"))}`;
            }
            
            wines.unshift({
                id: 'view_all_' + biggestProducer.productProducer.replace(/[^a-zA-Z0-9]/g, '_'),
                name: `View All ${biggestProducer.productProducer}`,
                vintage: '',
                ImageUrl: biggestProducer.imageUrl,
                url: producerUrl
            });
        }
    
        return wines;
    }

    function addAiSearch() {

            async function fetchAutocompleteResults($searchContainer) {

                let $searchElement = $searchContainer.find('input[type="search"]');
                let query = $searchElement.val();

                if (search !== query) {
                
                    let autocompleteUrl = `/search/auto-complete-ajax?search=${encodeURIComponent(query)}`;

                    if(isLTSearch()){
                        autocompleteUrl = autocompleteUrl + '&lt=true';
                    }

                    try {
                        let search = $searchElement.val();
                        $(".search-wrapper").addClass('active');

                        abortController.abort();
                        abortController = new AbortController();

                        const response = await fetch(autocompleteUrl, { signal: abortController.signal });
                        const results = await response.json();
                        if(search === $searchElement.val()) {
                            displayAutocompleteResults(results, $searchContainer);
                        }
                        $(".search-wrapper").removeClass('active');
                        search = $searchElement.val();
                    } catch (error) {
                        if (error.name !== 'AbortError') {
                            console.error('Error fetching autocomplete results:', error);
                        }
                    }
                }
            }

            function displayAutocompleteResults(results, $searchContainer) {

                const $resultsDiv = $searchContainer.find('.autocomplete-results');

                let $searchElement = $searchContainer.find('input[type="search"]');
                
                $resultsDiv.empty();

                let items = [];

                function addVintage(obj) {
                    if (!items.some(item => item.id === obj.id)) {
                        items.push(obj);
                    }
                }

                if (results) {
                    results.forEach(item => {

                        let productType = item["productType"];
                        let productRegion = item["productRegion"];
                        let productCountry = item["productCountry"];
                        let vintageWebUrl = item["vintageWebUrl"];
                        let vintageYear = (item["vintageYear"]=== '1000') ? '' : item["vintageYear"];
                        let productName = item["productName"];
                        let productProducer = item["productProducer"];
                        let ImageUrl = item["ImageUrl"];
                        let url = '';

                        if(!productCountry) {
                            return;
                        }

                        countryUniqueId = productCountry.replace(' ', '_');
                        
                        if (countryUniqueId && productRegion) {
                            regionUniqueId = `${countryUniqueId}.${productRegion.replace(' ', '_')}`;

                            const countryRegion = regionUniqueId.replace('.', '/');

                            if(isLTSearch()){
                                url = `/livetrade/marketplace/${productName}%20${vintageYear}`;
                            }
                            else {
                                // Check category and create the URL based on category
                                if (productType.toLowerCase() === 'spirit') {
                                    url = `/fine-spirits/${countryRegion}/${vintageWebUrl}`;
                                } else {
                                    url = `/fine-wine/${countryRegion}/${vintageWebUrl}`;
                                }
                            }

                            // Convert the URL to lowercase
                            url = url.toLowerCase();

                            let newItem = {
                                id: `${productName}${vintageYear}`,
                                name: productName,
                                vintage: vintageYear,
                                ImageUrl: ImageUrl,
                                url: url,
                                productProducer: productProducer,
                                productType: productType,
                            };

                            addVintage(newItem);
                        }
                    });

                    if(items.length > 0 && !isLTSearch()) {
                        items = addViewAllProducer(items);
                    }
                    
                    for (let i = 0; i < items.length; i++) {
                        let $img = $('<img>').attr('src', items[i].ImageUrl);
                        let $span = $('<span>').addClass('productName').text(`${items[i].vintage} ${items[i].name}`);
                        let $linkItem = $(`<a href="${items[i].url}" style="display: none;">`).addClass('autocomplete-item');
                        $linkItem.prepend($span);
                        
                        let $imgWrapper = $('<div>').addClass('autocompleteItemImage');
                        let $imgSizer = $('<div>').addClass('img-sizer');
                        $imgWrapper.append($imgSizer);

                        if(items[i].ImageUrl) {
                            $imgWrapper.append($img);
                        }
                        $linkItem.prepend($imgWrapper);
                        $resultsDiv.append($linkItem);
                        $linkItem.fadeIn(500);
                    }
                    
                }

                var clickedOnScrollbar = function(e){
                    if (e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight) 
                    {
                        return true
                    }
                }

                $(document).on('mousedown', function (event) {

                    if(clickedOnScrollbar(event)){
                        return;
                    }

                    if ($searchElement &&
                         !$searchElement.is(event.target) &&
                          $searchElement.has(event.target).length === 0 &&
                           $searchElement.is(':visible')) {
                        if (!event.target.closest('a')) {
                            $resultsDiv.empty();
                        }
                    }
                });
            }

            function setAISearchListener($searchContainer) {

                let debounce;
                let innerLink = '';
                let suppressSubmit = false;

                let $searchElement = $searchContainer.find('input[type="search"]');

                $searchElement.on('keydown input paste', function(e) {

                    setTimeout(() => { }, 0);
                    
                    if (suppressSubmit) {
                        e.preventDefault();
                        return false;
                    }

                    if (e.type == 'keydown') {
                        var code = (e.keyCode || e.which);
                
                        if (code == 37 || code == 38 || code == 39 || code == 40 || code == 13 || code == 32) {
                            return;
                        }
                    }
                    
                    clearTimeout(debounce);

                    if ($searchElement.val().length > 1) {
                        debounce = setTimeout(() => {
                            fetchAutocompleteResults($searchContainer);
                            
                        }, AUTO_COMPLETE_SPEED);
                    } else {
                        $searchContainer.find('.autocomplete-results').empty();
                    }
                });

                $searchContainer.on('submit', function (e) {
                    
                    let $newResultsDiv = $searchContainer.find('.autocomplete-results');
                    
                    let $hlightItem = $newResultsDiv.find('.hlight');
                    if ($hlightItem.length > 0) {
                        window.location.href = innerLink;
                        suppressSubmit = true;
                        $newResultsDiv.empty();
                        e.preventDefault();
                        return false;
                    } else {
                        abortController.abort();
                    }
                });

                let $resultsDiv = $('<div>').addClass('autocomplete-results');
                $searchContainer.append($resultsDiv);

                $(document).on('keyup', function (e) {
                    if (!$searchElement.is(':visible')) return;
                
                    const $results = $searchContainer.find('.autocomplete-results');
                
                    if (!$results.is(':visible')) return;
                
                    const $items = $results.find('.autocomplete-item');
                    const $current = $items.filter('.hlight');
                    let $next;
                
                    if (e.keyCode === 40) { // Down
                        $next = $current.next().length ? $current.next() : $items.first();
                    } else if (e.keyCode === 38) { // Up
                        $next = $current.prev().length ? $current.prev() : $items.last();
                    } else {
                        return; // Exit on irrelevant key
                    }
                
                    $items.removeClass('hlight');
                    $next.addClass('hlight');
                    $searchElement.val($next.text());
                    innerLink = $next.attr('href');
                
                    // Scroll to the newly highlighted element
                    if ($results.find('.hlight').length > 0) {
                        $results.scrollToElem('.hlight');
                    }
                });
            }

            // Add AI search to main search
            let $searchElementHeader = $('.header-search-form');
            setAISearchListener($searchElementHeader);

            let $mobileSearch = $('#quick_search_mobile');
            setAISearchListener($mobileSearch);

            let $ltMobileSearch = $('.marketplace .search-form.search.livetrade');
            setAISearchListener($ltMobileSearch);

            let $ltMobileSearchRegion = $('.marketplace-region .search-form.search.livetrade');
            setAISearchListener($ltMobileSearchRegion);
        
    }

    ldClient.waitForInitialization().then(() => {
        let isAiSearchEnabled = ldClient.variation('ai-search', false);

        if (isAiSearchEnabled) {
            addAiSearch();
        }
    })
    .catch((error) => {
        console.error('Failed to initialize LDClient:', error);
    });
});